<router-outlet></router-outlet>

<div class="overlay show" *ngIf="spinnerService.spinnerCounter$ | async">
    <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>
</div>